export default __webpack_public_path__ + "4655131b54767732d2fd91da5ed763d8.svg";